import React, {useState} from "react";
import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import SortableItem from "./SortableItem";
import {useIntl} from "react-intl";
import Button from "../../../../../components/elements/Button/Button";
import EventSheetAddField from "../EventSheetAddField";

export default function EventSheetDraggableFields({
                                                      sections,
                                                      setSections,
                                                      sectionKey,
                                                      sectionOptions,
                                                      context
                                                  }) {
    const intl = useIntl();
    const sensors = useSensors(useSensor(PointerSensor));
    const [fields, setFields] = useState(sections[sectionKey]);
    const [sectionKeySelected, setSectionKeySelected] = useState(null);
    const [fieldKeySelected, setFieldKeySelected] = useState(null);
    const [showAddFieldModal, setShowAddFieldModal] = useState(false);
    const handleAddOrEditField = (item) => {
        const newSections = {...sections}
        if (!fieldKeySelected) {
            const nextOrder = Object.keys(newSections[sectionKeySelected]).filter(k => k !== "order").length + 1;
            item.order = nextOrder
        }
        newSections[sectionKeySelected][item.value] = {...item}

        setFields(newSections[sectionKey])
        setSections(newSections);
        setSectionKeySelected(null)
        setFieldKeySelected(null)
        setShowAddFieldModal(false)
    };

    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        // Copiem secțiunile
        const newSections = { ...sections };

        // Transformăm fields (obiect) în array cu key și order
        let tempFields = Object.entries(fields)
            .filter(([k]) => k !== "order")
            .map(([key, value]) => ({
                key,
                ...value,
            }));

        // Sortăm după order
        const sortedFields = [...tempFields].sort((a, b) => (a.order || 0) - (b.order || 0));

        // Găsim pozițiile
        const oldIndex = sortedFields.findIndex((f) => f.key === active.id);
        const newIndex = sortedFields.findIndex((f) => f.key === over.id);

        // Reordonăm
        const reordered = arrayMove(sortedFields, oldIndex, newIndex);

        // Reconstruim obiectul cu ordinea recalculată
        const updated = reordered.reduce((acc, item, index) => {
            acc[item.key] = {
                ...item,
                order: index + 1,
            };
            return acc;
        }, {});
        // păstrăm order-ul secțiunii
        updated.order = sections[sectionKey].order;

        // actualizăm state
        newSections[sectionKey] = updated;
        setFields(updated);
        setSections(newSections);
    };

    return (
        <div className={"row"}>
            <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
            >
                <SortableContext
                    items={Object.keys(fields)
                        .filter(f => f !== "order")
                        .sort((a, b) => (fields[a].order || 0) - (fields[b].order || 0))}
                    strategy={verticalListSortingStrategy}
                >
                    {Object.keys(fields)
                        .filter(f => f !== "order")
                        .sort((a, b) => (fields[a].order || 0) - (fields[b].order || 0)).map((key) => (
                        <div className={"mt-2 " + fields[key].width} key={key} >
                            <SortableItem id={key} className={'card-field'}>

                                {intl.formatMessage({id: 'events.sheet.' + sectionKey + '.' + key})}
                                {!fields[key].required_field_in_sheet_template && <Button
                                    className={"btn-edit btn-light ms-auto"}
                                    icon={"fa-solid fa-pen"}
                                    type="button"
                                    onClick={() => {
                                        setSectionKeySelected(sectionKey)
                                        setFieldKeySelected(key);
                                        setShowAddFieldModal(true);
                                    }}/>}
                                {!fields[key].required_field_in_sheet_template && <Button
                                    className={"btn-light btn-delete ms-3"}
                                    icon="fa-solid fa-trash"
                                    type="button"
                                    onClick={() => {

                                        const newSections = {...sections};
                                        delete newSections[sectionKey][key]; // ștergem câmpul
                                        setFields(newSections[sectionKey])
                                        setSections(newSections);
                                        context.setContentUpdated(true);
                                    }}/>}

                            </SortableItem>
                        </div>

                    ))}
                </SortableContext>
            </DndContext>
            {/* Buton adaugă câmp */}
           <div className={"col-12"}>
               <Button
                   className="btn-primary mt-3 w-100"
                   icon="fa-solid fa-plus"
                   value={intl.formatMessage({id: "settings.event_sheet_templates.add_field"})}
                   onClick={() => {
                       setFieldKeySelected(null)
                       setSectionKeySelected(sectionKey)
                       setShowAddFieldModal(true)
                   }}
               />
               {/* Modal */}
               <EventSheetAddField
                   fieldKey={fieldKeySelected}
                   modalIsOpen={showAddFieldModal}
                   setModalIsOpen={setShowAddFieldModal}
                   onAdd={(item) => handleAddOrEditField(item)}
                   sections={sections}
                   sectionKey={sectionKey}
                   sectionOptions={sectionOptions}
               />
           </div>
        </div>
    );
}
